__turbopack_context__.v({
  "className": "caveat_bfdefc0e-module__GzYFnq__className",
  "variable": "caveat_bfdefc0e-module__GzYFnq__variable",
});
